import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { downloadTemplateBody, downloadingTemplateBody, footerDescargaDatos, footerDescargando, 
	footerDescargaDatosExito } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { saveAs } from 'file-saver';
const ExcelJS = require('exceljs');
const JSZip = require("jszip");

import metadatos from 'bundle-text:../data/METADATA.md';

import { Sesion, Datos } from '../main.js';
import { parcelasSP } from './plots.js';
import { downloadPlotInfo } from './dataManager.js';
import { getLiteral, uriToLiteral, getDate, configurarModal } from './util.js';
import { initTimedEvent, sendTimedEvent } from './events.js';


function prepararDescarga() {
	// recupero el total de parcelas a descargar del inventario
	const np = parcelasSP[Sesion.estado.ifn].size;
	if (np == 0) { 	// aviso con un toast de que no hay parcelas para descargar
		document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
		document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.noplots);
		const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
		tostada.show();
		return;
	}
		
	// preparo objeto plantilla para el modal
	const tobjbody = {
		ifn2: Sesion.estado.ifn === "ifn2",
		ifn3: Sesion.estado.ifn === "ifn3"
	};
	
	// inicialización modal con petición de confirmación
	const htmlbody = Mustache.render(downloadTemplateBody, tobjbody);
	configurarModal( { static: true }, //{ static: true, vertcent: true}, 
		getLiteral(dict.downloadData), htmlbody, footerDescargaDatos);		
	// muestro el modal
	const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
	mimodal.show();

	// pongo listener a los checks de IFN para mensajillo y para habilitar el botón de descarga
	document.querySelectorAll('.check-ifn').forEach(function(checkbox) {
		checkbox.addEventListener('change', function() {
			const algunifn = Array.from(document.querySelectorAll('.check-ifn'))
				.some((el) => el.checked);
			if (algunifn) {
				document.getElementById('downloadNoIFN').classList.add("d-none");
				const algunformato = Array.from(document.querySelectorAll('.radio-format'))
					.some((el) => el.checked);
				document.getElementById('downloadData').disabled = !algunformato;
			} 
			else {
				document.getElementById('downloadNoIFN').classList.remove("d-none");
				document.getElementById('downloadData').disabled = true;
			}
		});
	});
		
	// pongo listener al radio para habilitar el botón de descarga
	document.querySelectorAll('.radio-format').forEach(function(radio) {
		radio.addEventListener('change', function() {
			document.getElementById('downloadNoFormat').classList.add("d-none");
			const algunifn = Array.from(document.querySelectorAll('.check-ifn'))
				.some((el) => el.checked);
			document.getElementById('downloadData').disabled = !algunifn;
		});
	});
	
	// listener al botón de descarga
	document.getElementById('downloadData').addEventListener('click', function() {
		const objdescarga = { ifns: [], format: "GeoJSON" }; // default format
		// extraigo ediciones ifn
		if (document.getElementById('checkIFN2').checked)
			objdescarga.ifns.push("ifn2");
		if (document.getElementById('checkIFN3').checked)
			objdescarga.ifns.push("ifn3");
		// detecto el formato de descarga 
		if (document.getElementById('CSV').checked)
			objdescarga.format = "CSV";
		else if (document.getElementById('XLSX').checked)
			objdescarga.format = "XLSX";
		// llamo a descargar los datos
		descargarDatos(objdescarga);
	});
}


async function descargarDatos(objd) {
	// inicializo datos para timed event
	const dte = { content_type: 'download', format: objd.format };

	// actualizo modal
	const mbobj = {};
	for (const ifn of objd.ifns) {
		mbobj[ifn] = true;
		mbobj["plots" + ifn] = parcelasSP[ifn].size;
		dte["num_plots_" + ifn] = parcelasSP[ifn].size;
	}
	const modalbody =  Mustache.render(downloadingTemplateBody, mbobj);
	configurarModal( { static: true }, null, modalbody, footerDescargando);
		
	// inicializo TimedEvent GA
	initTimedEvent(dte);
	
	// pido la descarga de parcelas
	const plotreq = {};
	for (const ifn of objd.ifns)
		plotreq[ifn] = [...parcelasSP[ifn]]; // convierto de set a array
	const cancelado = await downloadPlotInfo(plotreq);	
	if (cancelado)
		return; // nada más que hacer si el usuario canceló
	
	// inicializaciones salida	
	const CSV = objd.format === 'CSV';
	const outputs = []; 	// inicializo array de salidas
	const workbook = objd.format === 'XLSX'? new ExcelJS.Workbook() : null; // workbook para el Excel
		
	// para cada versión del inventario...
	for (const ifn of objd.ifns) {
		// ordeno piris
		//const piris = plotreq[ifn].sort();
		// ordeno piris primero por provincia y luego por número de parcela
		const piris = plotreq[ifn].sort((a, b) => {
			const pra = Number(a.split('/plot-')[1].split('-')[0]);
			const ida = Number(a.split('/plot-')[1].split('-')[1]);
			const prb = Number(b.split('/plot-')[1].split('-')[0]);
			const idb = Number(b.split('/plot-')[1].split('-')[1]);
			if (pra == prb)
				return ida - idb;
			else
				return pra - prb;
		});
		
		// preparo datos de descarga de las parcelas y árboles
		let parcelas = [];
		let arboles = [];
		for (const piri of piris) {
			// rehago para controlar el orden de las claves del JSON
			// inicializo parcela con los datos de descarga y con las coordenadas (extraídas antes)
			let props = {};
			let parcela = {
				type: "Feature",
				properties: props,
				//properties: JSON.parse(JSON.stringify(Datos.parcelasDescarga[piri])), // deep copy
				geometry: {
					type: "Point",
					coordinates: [ Datos.parcelas[piri].lng, Datos.parcelas[piri].lat ]
				} 
			}
			// preparo propiedades
			const pd = Datos.parcelasDescarga[piri];
			props.plotId = uriToLiteral(piri, "plot-");
			props.plotIri = piri;
			props.ifn = ifn;
			if (Datos.parcelas[piri].prov && Datos.provs[Datos.parcelas[piri].prov])
				props.province = getLiteral(Datos.provs[Datos.parcelas[piri].prov].label);
			if (Datos.parcelas[piri].muni && Datos.munis[Datos.parcelas[piri].muni])
				props.municipality = getLiteral(Datos.munis[Datos.parcelas[piri].muni].label);	
			if (Datos.parcelas[piri].plotifn2) {
				props.plotifn2Id = uriToLiteral(Datos.parcelas[piri].plotifn2, "plot-");
				props.plotifn2Iri = Datos.parcelas[piri].plotifn2;
			}
			if (Datos.parcelas[piri].plotifn3) {
				props.plotifn3Id = uriToLiteral(Datos.parcelas[piri].plotifn3, "plot-");
				props.plotifn3Iri = Datos.parcelas[piri].plotifn3;
			}
			if (Datos.parcelas[piri].dataCapture)
				props.dataCapture = getDate(Datos.parcelas[piri].dataCapture);			
			if (pd.infoSpecies) {
				let pdis = JSON.parse(JSON.stringify(pd.infoSpecies)); // deep copy
				props.infoSpecies = [];
				pdis = Array.isArray(pdis)? pdis : [pdis];
				for (let pis of pdis) {
					// preparo cada infospecies
					let is = {};
					props.infoSpecies.push(is);
					// id e iri
					is.infoSpeciesId = uriToLiteral(pis.iri);
					is.infoSpeciesIri = pis.iri;
					// especie
					if (pis.species) {
						is.speciesId = uriToLiteral(pis.species);
						is.speciesIri = pis.species;
						if (Datos.taxones[pis.species])
							is.scientificName = getLiteral(Datos.taxones[pis.species].scientificName);
					}
					// percentageOfSpecies
					if (pis.percentageOfSpecies)
						is.percentageOfSpecies = pis.percentageOfSpecies;
					// ageInYears
					if (pis.ageInYears)
						is.ageInYears = pis.ageInYears;
					// inclusión numberTreesHa
					if (Datos.parcelas[piri].nt[pis.species])
						is.numberTreesHa = Datos.parcelas[piri].nt[pis.species];
					// inclusión basalAreaM2Ha
					if (Datos.parcelas[piri].ba[pis.species])
						is.basalAreaM2Ha = Datos.parcelas[piri].ba[pis.species];
					// inclusión volumeOverBarkM3Ha
					if (Datos.parcelas[piri].vwb[pis.species])
						is.volumeOverBarkM3Ha = Datos.parcelas[piri].vwb[pis.species];
					// inclusión volumeUnderBarkM3Ha
					if (Datos.parcelas[piri].vwob[pis.species])
						is.volumeUnderBarkM3Ha = Datos.parcelas[piri].vwob[pis.species];				
				}			
			}
			/* prueba infoSpecies poco exitosa
			if (Datos.parcelas[piri].nt) {
				props.infoSpecies = [];
				// comienzo con las existencias de la parcela
				for (const sp in Datos.parcelas[piri].nt) {
					// preparo cada infospecies
					let is = {};
					props.infoSpecies.push(is);
					// especie
					is.speciesId = uriToLiteral(sp);
					is.speciesIri = sp;
					if (Datos.taxones[sp])
						is.scientificName = getLiteral(Datos.taxones[sp].scientificName);
					// inclusión numberTreesHa
					if (Datos.parcelas[piri].nt[sp])
						is.numberTreesHa = Datos.parcelas[piri].nt[sp];
					// inclusión basalAreaM2Ha
					if (Datos.parcelas[piri].ba[sp])
						is.basalAreaM2Ha = Datos.parcelas[piri].ba[sp];
					// inclusión volumeWithBarkM3Ha
					if (Datos.parcelas[piri].vwb[sp])
						is.volumeWithBarkM3Ha = Datos.parcelas[piri].vwb[sp];
					// inclusión volumeWithoutBarkM3Ha
					if (Datos.parcelas[piri].vwob[sp])
						is.volumeWithoutBarkM3Ha = Datos.parcelas[piri].vwob[sp];
					
					// sigo con la edad y porcentaje, si es que están	
					if (pd.infoSpecies) {
						const pdis = Array.isArray(pd.infoSpecies)? pd.infoSpecies : [pd.infoSpecies];
						const isel = pdis.find(isc => isc.species === sp);
						if (isel) {
							// percentageOfSpecies
							if (isel.percentageOfSpecies)
								is.percentageOfSpecies = isel.percentageOfSpecies;
							// ageInYears
							if (isel.ageInYears)
								is.ageInYears = isel.ageInYears;						
						}
					}
				}
			}*/
			if (pd.trees)
				props.trees = JSON.parse(JSON.stringify(pd.trees)); // deep copy
			// procesamiento de los árboles
			if (props.trees) {
				const trees = Array.isArray(props.trees)?
					props.trees : [props.trees];
				for (const tree of trees) {
					let apr = {};
					let arbol = {
						type: "Feature",
						//properties: JSON.parse(JSON.stringify(tree)), // deep copy
						properties: apr,
						geometry: {
							type: "Point",
							coordinates: [ tree.lng, tree.lat ]
						} 
					}
					// preparo propiedades
					//apr.treeId = tree.isDead? 
					//	uriToLiteral(tree.iri, "deadTree-") : uriToLiteral(tree.iri, "tree-");
					apr.treeId = uriToLiteral(tree.iri, "tree-");
					apr.treeIri = tree.iri;
					apr.order = tree.order;
					apr.ifn = ifn;
					apr.plotId = uriToLiteral(piri, "plot-");
					apr.plotIri = piri;
					if (parcela.properties.province)
						apr.province = parcela.properties.province;
					if (parcela.properties.municipality)
						apr.municipality = parcela.properties.municipality;
					if (parcela.properties.dataCapture)
						apr.dataCapture = parcela.properties.dataCapture;					
					//if (tree.isDead)
					//	apr.isDead = true;
					if (tree.species) {
						apr.speciesId = uriToLiteral(tree.species);
						apr.speciesIri = tree.species;						
						if (Datos.taxones[tree.species])
							apr.scientificName = getLiteral(Datos.taxones[tree.species].scientificName);
					}
					apr.dbh1mm = tree.dbh1mm;
					apr.dbh2mm = tree.dbh2mm;
					apr.heightM = tree.heightM;
					if (tree.quality)
						apr.quality = tree.quality;
					apr.expan = tree.expan;
					if (tree.treeifn2) {
						if (Array.isArray(tree.treeifn2)) {
							apr.treeifn2Id = [];
							for (const tiri of tree.treeifn2) {
								//const tirid = uriToLiteral(uriToLiteral(tiri, "deadTree-"), "tree-");
								const tirid = uriToLiteral(tiri, "tree-");
								apr.treeifn2Id.push(tirid);
							}
						}
						else {
							//const tirid = uriToLiteral(uriToLiteral(tree.treeifn2, "deadTree-"), "tree-");
							const tirid = uriToLiteral(tree.treeifn2, "tree-");
							apr.treeifn2Id = tirid;
						}
						apr.treeifn2Iri = tree.treeifn2;
					}
					if (tree.treeifn3) {
						if (Array.isArray(tree.treeifn3)) {
							apr.treeifn3Id = [];
							for (const tiri of tree.treeifn3) {
								//const tirid = uriToLiteral(uriToLiteral(tiri, "deadTree-"), "tree-");
								const tirid = uriToLiteral(tiri, "tree-");
								apr.treeifn3Id.push(tirid);
								//arbol.properties.treeifn3Id.push(uriToLiteral(tiri));
							}
						}
						else {
							//const tirid = uriToLiteral(uriToLiteral(tree.treeifn3, "deadTree-"), "tree-");
							const tirid = uriToLiteral(tree.treeifn3, "tree-");
							apr.treeifn3Id = tirid;						
							//arbol.properties.treeifn3Id = uriToLiteral(arbol.properties.treeifn3);
						}
						apr.treeifn3Iri = tree.treeifn3;
					}
					// guardo árbol
					arboles.push(arbol);
				}
				// guardo iris de los árboles ordenadas
				//parcela.properties.trees = trees.map((tree) => tree.iri).sort();
				// parece que funciona esta ordenación incluso con las nuevas IRIs de árboles
				parcela.properties.trees = trees.map((tree) => tree.iri).sort((a, b) => {
					const nta =  Number(a.split('-')[a.split('-').length -1]);
					const ntb =  Number(b.split('-')[b.split('-').length -1]);
					return nta - ntb;
				});
			}
			// guardo parcela
			parcelas.push(parcela);	
		}
		// ordeno árboles (primero por plotId y luego por order)
		arboles.sort((a, b) => {
			if (a.properties.plotId === b.properties.plotId)
				return a.properties.order - b.properties.order;
			else
				return a.properties.plotId.localeCompare(b.properties.plotId);
		});
				
		// genero datos descarga de parcelas
		if (parcelas.length > 0)  {
			let nfich = getLiteral(dict.plotsFile) + ifn;
			if (objd.format === 'GeoJSON') { // GeoJSON
				const geoJSON = {
					type: 'FeatureCollection',
					features: parcelas
				};
				const output = {
					data: JSON.stringify(geoJSON, null, 2),
					nfich: nfich + ".geojson",
					type: 'application/geo+json'
				};
				outputs.push(output);
			}
			else { // CSV o XLSX
				// fichero de parcelas
				// CSV header
				const otroplot = ifn === "ifn2"? "plotifn3" : "plotifn2";
				let header = [ "plotId", "ifn", "province", "municipality", "latWGS84", "lngWGS84", "dataCapture", 
					otroplot+"Id", "plotIri", otroplot+"Iri"];
				// Generate the CSV rows
				let rows = parcelas.map(feature => {
					return header.map(key => {
						let value = undefined;
						if (key === "latWGS84")
							value = feature.geometry.coordinates[1];
						else if (key === "lngWGS84")
							value = feature.geometry.coordinates[0];
						else
							value = feature.properties[key];
						// procesamiento cadenas para CSV
						if (CSV) {
							if (typeof value === 'string' || value instanceof String)
								value = '"' + value.replace('"', '""') + '"';
						}
						// devuelvo
						return value;
					});
				});
				if (CSV) {
					// Combine the header and rows into a single CSV string
					const output = {
						data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
						nfich: nfich + ".csv",
						type: 'text/csv;charset=utf-8'
					};
					outputs.push(output);
				}
				else { // XLSX
					// Create a new worksheet
					const worksheet = workbook.addWorksheet(nfich);
					// añado los datos
					worksheet.addRow(header);
					rows.forEach(row => {
						worksheet.addRow(row);
					});
				}				
				// fichero de infoSpecies
				// CSV header
				//header = [ "iri", "plot", "province", "numberTreesHa", "percentage", "species", "scientificName"];
				header = [ "infoSpeciesId", "ifn", "plotId", "province", "municipality", "speciesId", "scientificName",
					"percentageOfSpecies", "numberTreesHa", "basalAreaM2Ha", "volumeOverBarkM3Ha", "volumeUnderBarkM3Ha",					
					 "ageInYears", "infoSpeciesIri", "plotIri",  "speciesIri" ];					 
				// Generate the CSV rows
				const filParcelas = parcelas.filter((par) => par.properties.infoSpecies);
				rows = filParcelas.flatMap(feature => {
					return feature.properties.infoSpecies.map(is => {
						return header.map(key => {
							let value = undefined;
							if (key === "plotId")
								value = feature.properties.plotId;
							else if (key === "plotIri")
								value = feature.properties.plotIri;
							else if (key === "ifn")
								value = ifn;
							else if (key === "province")
								value = feature.properties.province;
							else if (key === "municipality")
								value = feature.properties.municipality;
							else
								value = is[key];
							// procesamiento cadenas para CSV
							if (CSV) {
								if (typeof value === 'string' || value instanceof String)
									value = '"' + value.replace('"', '""') + '"';
							}
							// devuelvo
							return value;
						});
					});
				});
				if (rows.length > 0) {
					if (CSV) {
						// Combine the header and rows into a single CSV string
						const output = {
							data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
							nfich: getLiteral(dict.infoplotsFile) + ifn + ".csv",
							type: 'text/csv;charset=utf-8'
						};
						outputs.push(output);
					}
					else { // XLSX
						// Create a new worksheet
						const worksheet = workbook.addWorksheet(getLiteral(dict.infoplotsFile) + ifn);
						// añado los datos
						worksheet.addRow(header);
						rows.forEach(row => {
							worksheet.addRow(row);
						});
					}
				}
			}
		}
				
		// genero datos descarga de árboles
		if (arboles.length > 0) {
			let nfich = getLiteral(dict.treesFile) + ifn;
			if (objd.format === 'GeoJSON') { // GeoJSON
				const geoJSON = {
					type: 'FeatureCollection',
					features: arboles
				};
				const output = {
					data: JSON.stringify(geoJSON, null, 2),
					nfich: nfich + ".geojson",
					type: 'application/geo+json'
				};
				outputs.push(output);
			}
			else { // CSV o XLSX
				// fichero de árboles
				// CSV header
				const otrotree = ifn === "ifn2"? "treeifn3" : "treeifn2";
				//let header = [ "iri", "ifn", "plot", "province", "latWGS84", "lngWGS84", "dbh1mm", "dbh2mm", 
				//	"heightM", "expan", "species", "scientificName", "dataCapture", otrotree];
				let header = [ "treeId", "order", "ifn", "plotId", "province", "municipality",
					"latWGS84", "lngWGS84", "dbh1mm", "dbh2mm", "heightM", "quality", "expan", 
					"speciesId", "scientificName", "dataCapture", otrotree+"Id",
					"treeIri", "plotIri", "speciesIri", otrotree+"Iri"];			
				// Generate the CSV rows
				let rows = arboles.map(feature => {
					return header.map(key => {
						let value = undefined;
						if (key === "latWGS84")
							value = feature.geometry.coordinates[1];
						else if (key === "lngWGS84")
							value = feature.geometry.coordinates[0];
						else
							value = feature.properties[key];
						// procesamiento cadenas para CSV
						if (CSV) {
							if (typeof value === 'string' || value instanceof String)
								value = '"' + value.replace('"', '""') + '"';
						}
						// devuelvo
						return value;
					});
				});
				if (rows.length > 0) {
					if (CSV) {
						// Combine the header and rows into a single CSV string
						const output = {
							data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
							nfich: nfich + ".csv",
							type: 'text/csv;charset=utf-8'
						};
						outputs.push(output);
					}
					else { // XLSX
						// Create a new worksheet
						const worksheet = workbook.addWorksheet(nfich);
						// añado los datos
						worksheet.addRow(header);
						rows.forEach(row => {
							worksheet.addRow(row);
						});
					}
				}
			}
		}
	}
	
	// preparo la salida para XLSX a partir del workbook
	if (objd.format === 'XLSX') {
		const buffer = await workbook.xlsx.writeBuffer();
		outputs.push({
			data: buffer,
			nfich: getLiteral(dict.downloadFile) + ".xlsx",
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
	}
	
	// siempre genero un zip
	const zip = new JSZip();
	// incluyo los ficheros
	for (const out of outputs) {
		const blob = new Blob([out.data], {type: out.type});
		zip.file(out.nfich, blob);
	}
	// ahora incluyo los metadatos
	zip.file("METADATA.md", metadatos);
	// genero el zip
	const datoszip = await zip.generateAsync({type : "uint8array"});
	// y lo sirvo
	const blob = new Blob([datoszip], {type: "application/zip"});
	saveAs(blob, getLiteral(dict.downloadFile) + ".zip");
	
	
	/* TODO previo
	// si sólo hay un fichero, sin zip (ej. una parcela sin árboles)
	if (outputs.length == 1) {
		const out = outputs[0];
		const blob = new Blob([out.data], {type: "text/plain;charset=utf-8"});
		saveAs(blob, out.nfich);
	}
	else { // si hay varios ficheros preparo un zip
		const zip = new JSZip();
		for (const out of outputs) {
			const blob = new Blob([out.data], {type: "text/plain;charset=utf-8"});
			zip.file(out.nfich, blob);
		}
		const datoszip = await zip.generateAsync({type : "uint8array"});
		const blob = new Blob([datoszip], {type: "text/plain;charset=utf-8"});
		saveAs(blob, getLiteral(dict.downloadFile) + ".zip");
	}*/
	
	// escondo mensajillo de preparando ficheros
	document.getElementById('preparingFiles').classList.add('d-none');
	
	// actualizo mensajillo de info
	document.getElementById('downloadSuccess').classList.remove('d-none');
		
	// actualizo modal
	configurarModal( { static: true }, //{ static: true, vertcent: true}, 
		null, null, footerDescargaDatosExito);	
		
	// mando evento temporizado
	sendTimedEvent();
}


export { prepararDescarga };